module.exports = __webpack_public_path__ + "static/media/EG-M302.4227f7d8.jpg";